import { render, staticRenderFns } from "./DiamondIcon.vue?vue&type=template&id=23a33fe6&"
import script from "./DiamondIcon.vue?vue&type=script&lang=ts&"
export * from "./DiamondIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports